export default "__VITE_ASSET__Dx6tyUio__"